import {AccordionData} from "../../../global/interfaces/AccordionData";
import {Change, status} from "../../../global/interfaces/Change";
import {v4 as uuid} from "uuid";

export const createChangeFromAccordionData = (originalValue: AccordionData, changedValue: AccordionData, suchname: string, name: string): Change => {

    return {
        datum: new Date().toISOString(),
        feld: originalValue.field?.toString() || "",
        id: uuid(),
        name: name,
        status: status.PENDING,
        suchname,
        wertAenderung: changedValue.value?.toString() || "",
        wertOriginal: originalValue?.value?.toString() || ""
    }
}